import { render, staticRenderFns } from "./TemplateDeArchive.vue?vue&type=template&id=881f17fa"
import script from "./TemplateDeArchive.vue?vue&type=script&lang=js"
export * from "./TemplateDeArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports